//import logo from "./logo.svg";
import { lazy } from "react";
import { Routes, Route } from "react-router-dom";

import "App.css";
import Header from "components/Header";
import Home from "pages/Home";
import Footer from "components/Footer";
import ScrollToTop from "components/ScrollToTop";
import RouteMap from "config/RouteMap";

const Slots = lazy(() => import("pages/Slots"));
const LiveCasino = lazy(() => import("pages/LiveCasino"));
const Sports = lazy(() => import("pages/Sports"));
const Lottery = lazy(() => import("pages/Lottery"));
const Download = lazy(() => import("pages/Download"));
const Login = lazy(() => import("pages/Login"));
const Register = lazy(() => import("pages/Register"));
const Promotions = lazy(() => import("pages/Promotions"));
const NotFound = lazy(() => import("pages/NotFound"));

function App() {
  return (
    <div className="App">
      <Header />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path={RouteMap.slots} element={<Slots />} />
          <Route path={RouteMap.liveCasino} element={<LiveCasino />} />
          <Route path={RouteMap.sports} element={<Sports />} />
          <Route path={RouteMap.lottery} element={<Lottery />} />
          <Route path={RouteMap.download} element={<Download />} />
          <Route path={RouteMap.login} element={<Login />} />
          <Route path={RouteMap.register} element={<Register />} />
          <Route path={RouteMap.promotions} element={<Promotions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
